export const DV2_GROUPS = [
  {
    key: 'habilitada',
    label: 'Habilitadas',
    desc: 'Serviços ativos no portal',
    color: 'var(--ci2-green, #17845a)',
  },
  {
    key: 'desabilitada',
    label: 'Desabilitadas',
    desc: 'Ainda não habilitadas',
    color: 'var(--ci2-gray, #767889)',
  },
];

export const DEFEITOS_COL_TOGGLE_KEYS = [
  'codigo',
  'board',
  'color',
  'classificacao',
  'sugestao',
  'criticidade',
  'tipo_os',
  'equipamentos',
];

export const DEFEITOS_COL_LABELS = {
  codigo: 'Código',
  board: 'Cód. board',
  color: 'Cor',
  classificacao: 'Classificação',
  sugestao: 'Sugestão',
  criticidade: 'Criticidade',
  tipo_os: 'Tipo de OS',
  equipamentos: 'Equipamentos',
};

export const DEFEITOS_DV2_CENTER_COL_KEYS = ['board', 'color', 'sugestao', 'criticidade', 'tipo_os', 'equipamentos'];

export const DEFEITOS_SORT_OPTIONS = [
  { key: 'nome', label: 'Serviço' },
  { key: 'codigo', label: 'Código' },
  { key: 'board', label: 'Cód. board' },
  { key: 'classificacao', label: 'Classificação' },
  { key: 'criticidade', label: 'Criticidade' },
  { key: 'habilitado', label: 'Habilitar' },
];

export function getDefeitoSortValue(row, key) {
  switch (key) {
    case 'nome':
      return String(row.TB01048_NOME ?? '');
    case 'codigo':
      return String(row.TB01048_CODIGO ?? '');
    case 'board':
      return String(row.cod_alert ?? '');
    case 'classificacao':
      return String(row.classification ?? '');
    case 'criticidade':
      return String(row.severity_level ?? '');
    case 'habilitado':
      return row.habilitado === 1 || row.habilitado === true ? '1' : '0';
    default:
      return '';
  }
}

export const fullDefeitosVisibilityState = () =>
  DEFEITOS_COL_TOGGLE_KEYS.reduce((acc, k) => {
    acc[k] = k !== 'codigo';
    return acc;
  }, {});

export function categorizeDefeitoRow(row) {
  const enabled = row.habilitado === 1 || row.habilitado === true;
  return enabled ? 'habilitada' : 'desabilitada';
}
